module.exports = __webpack_public_path__ + "img/Cantal.758c3c96.png";